// extracted by mini-css-extract-plugin
export var awards = "Awards-module--awards--341Fi";
export var center = "Awards-module--center--3-acq";